import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'index',
		component: index,
		children: [
			{
				path: 'home/home', //首页
				name: 'home',
				component: () =>
					import( /* webpackChunkName: "home" */ '../views/home/home.vue'),
				meta: {
					title: '首页'
				}
			},
			{
				path: 'companyManage/companyManage', //公司管理
				name: 'companyManage',
				component: () =>
					import( /* webpackChunkName: "companyManage" */ '../views/companyManage/companyManage.vue'),
				meta: {
					title: '公司管理'
				}
			},
			{
				path: 'companyEdit', //
				name: 'companyEdit',
				component: () =>
					import( /* webpackChunkName: "companyManage" */ '../views/companyManage/companyEdit.vue'),
				meta: {
					title: '公司管理'
				}
			},
			
			{
				path: 'mediaManage/mediaManage', //
				name: 'mediaManage',
				component: () =>
					import( /* webpackChunkName: "mediaManage" */ '../views/mediaManage/mediaManage.vue'),
				meta: {
					title: '媒体管理'
				}
			},
			{
				path: 'aggregation/applicationManage', //聚合管理
				name: 'applicationManage',
				component: () =>
					import( /* webpackChunkName: "aggregation" */ '../views/aggregation/applicationManage.vue'),
				meta: {
					title: '应用管理'
				}
			},
			{
				path: 'appEdit', //
				name: 'appEdit',
				component: () =>
					import( /* webpackChunkName: "aggregation" */ '../views/aggregation/appEdit.vue'),
				meta: {
					title: '应用管理'
				}
			},
			{
				path: 'aggregation/ADNetwork', //
				name: 'ADNetwork',
				component: () =>
					import( /* webpackChunkName: "aggregation" */ '../views/aggregation/ADNetwork.vue'),
				meta: {
					title: '广告网络'
				}
			},
			{
				path: 'aggregation/adSpaceManage', //
				name: 'adSpaceManage',
				component: () =>
					import( /* webpackChunkName: "aggregation" */ '../views/aggregation/adSpaceManage.vue'),
				meta: {
					title: '广告位管理'
				}
			},
			{
				path: 'adSpaceEdit', //
				name: 'adSpaceEdit',
				component: () =>
					import( /* webpackChunkName: "aggregation" */ '../views/aggregation/adSpaceEdit.vue'),
				meta: {
					title: '广告位编辑'
				}
			},
			{
				path: 'adSpaceConfig', //
				name: 'adSpaceConfig',
				component: () =>
					import( /* webpackChunkName: "aggregation" */ '../views/aggregation/adSpaceConfig.vue'),
				meta: {
					title: '广告位配置'
				}
			},
			{
				path: 'accessCenter/SDKIntegration', //接入中心
				name: 'SDKIntegration',
				component: () =>
					import( /* webpackChunkName: "accessCenter" */ '../views/accessCenter/SDKIntegration.vue'),
				meta: {
					title: 'SDK集成'
				}
			},
			
			{
				path: 'dataReport/comprehensiveReport', //数据管理
				name: 'comprehensiveReport',
				component: () =>
					import( /* webpackChunkName: "dataReport" */ '../views/dataReport/comprehensiveReport.vue'),
				meta: {
					title: '综合报表'
				}
			},
			{
				path: 'dataReport/mediaIncome', //数据管理
				name: 'mediaIncome',
				component: () =>
					import( /* webpackChunkName: "dataReport" */ '../views/dataReport/mediaIncome.vue'),
				meta: {
					title: '媒体收入'
				}
			},
			{
				path: 'dataReport/appData', //
				name: 'appData',
				component: () =>
					import( /* webpackChunkName: "dataReport" */ '../views/dataReport/appData.vue'),
				meta: {
					title: '应用数据'
				}
			},
			{
				path: 'dataReport/mediaData', //
				name: 'mediaData',
				component: () =>
					import( /* webpackChunkName: "dataReport" */ '../views/dataReport/mediaData.vue'),
				meta: {
					title: '媒体数据'
				}
			},
			{
				path: 'dataReport/timeShareReport', //
				name: 'timeShareReport',
				component: () =>
					import( /* webpackChunkName: "dataReport" */ '../views/timeShareReport/index.vue'),
				meta: {
					title: '分时报表'
				}
			},
			{
				path: 'dataReport/channelData', //
				name: 'channelData',
				component: () =>
					import( /* webpackChunkName: "dataReport" */ '../views/dataReport/channelData.vue'),
				meta: {
					title: '渠道数据'
				}
			},
			{
				path: 'dataReport/versionStatistics', //
				name: 'versionStatistics',
				component: () =>
					import( /* webpackChunkName: "dataReport" */ '../views/dataReport/versionStatistics.vue'),
				meta: {
					title: '版本统计'
				}
			},
			{
				path: 'operationalAnalysis/sourceAnalysis', //运营分析
				name: 'sourceAnalysis',
				component: () =>
					import( /* webpackChunkName: "operationalAnalysis" */ '../views/operationalAnalysis/sourceAnalysis.vue'),
				meta: {
					title: '素材分析'
				}
			},
			{
				path: 'operationalAnalysis/budgetMap', //
				name: 'budgetMap',
				component: () =>
					import( /* webpackChunkName: "operationalAnalysis" */ '../views/operationalAnalysis/budgetMap.vue'),
				meta: {
					title: '预算映射'
				}
			},
			{
				path: 'financeAccount/mediaAccount', //财务对账
				name: 'mediaAccount',
				component: () =>
					import( /* webpackChunkName: "financeAccount" */ '../views/financeAccount/mediaAccount.vue'),
				meta: {
					title: '媒体对账单'
				}
			},
			{
				path: 'financeAccount/recordPayment', //
				name: 'recordPayment',
				component: () =>
					import( /* webpackChunkName: "financeAccount" */ '../views/financeAccount/recordPayment.vue'),
				meta: {
					title: '对账打款'
				}
			},
			{
				path: 'SDKVersion/SDKVersion', //
				name: 'SDKVersion',
				component: () =>
					import( /* webpackChunkName: "SDKVersion" */ '../views/SDKVersion/SDKVersion.vue'),
				meta: {
					title: 'SDK版本管理'
				}
			},
			{
				path: 'approvalPending/comanyQuality', //审批待办
				name: 'comanyQuality',
				component: () =>
					import( /* webpackChunkName: "approvalPending" */ '../views/approvalPending/comanyQuality.vue'),
				meta: {
					title: '公司资质'
				}
			},
			{
				path: 'approvalPending/applicationQuality', //
				name: 'applicationQuality',
				component: () =>
					import( /* webpackChunkName: "approvalPending" */ '../views/approvalPending/applicationQuality.vue'),
				meta: {
					title: '应用资质'
				}
			},
			{
				path: 'approvalPending/accountRegist', //
				name: 'accountRegist',
				component: () =>
					import( /* webpackChunkName: "approvalPending" */ '../views/approvalPending/accountRegist.vue'),
				meta: {
					title: '账号注册'
				}
			},
			{
				path: 'accountManage/userManage', //
				name: 'userManage',
				component: () =>
					import( /* webpackChunkName: "accountManage" */ '../views/accountManage/userManage.vue'),
				meta: {
					title: '账户管理'
				}
			},
			{
				path: 'accountManage/roleManage', //
				name: 'roleManage',
				component: () =>
					import( /* webpackChunkName: "accountManage" */ '../views/accountManage/roleManage.vue'),
				meta: {
					title: '角色管理'
				}
			},
			{
				path: 'personal', //以
				name: 'personal',
				component: () =>
					import( /* webpackChunkName: "personal" */ '../views/personal/personalCenter.vue'),
				meta: {
					title: '个人信息'
				}
			},
			{
				path: 'Loan/Loan/index', //以
				name: 'Loan/Loan/index',
				component: () =>
					import( /* webpackChunkName: "followTypeAdmin" */ '../views/personal/personalInfo.vue'),
				meta: {
					title: '账号信息'
				}
			},
			{
				path: 'Loan/Loan/updatepwd', //以
				name: 'Loan/Loan/updatepwd',
				component: () =>
					import( /* webpackChunkName: "followTypeAdmin" */ '../views/personal/resetPwd.vue'),
				meta: {
					title: '修改密码'
				}
			},
		]
	},
	{
		path: '/login',
		name: 'login',
		component: () =>
			import( /* webpackChunkName: "login" */ '../views/login/login.vue'),
		meta: {
			title: ''
		},
		
	},
	{
		path: '/404',
		name: '404',
		component: () => import( /* webpackChunkName: "error" */ '../views/error/404.vue'),
		meta: { title: '404' },
	},
	// ,{
	// 	path: '/maps',
	// 	name: 'maps',
	// 	component: () => import( /* webpackChunkName: "about" */ '../views/maps.vue')
	// }

]
let allAuthRoutes = [
	{ path: 'companyManage/companyManage' },//公司管理
	{ path: 'mediaManage/mediaManage', },
	{ path: 'adSpaceManage/adSpaceManage',}, // 广告位管理
	{ path: 'dataReport/mediaIncome', },//媒体收入
	{ path: 'dataReport/appData', }, // 应用数据
	{ path: 'dataReport/dataShow', 	}, // 媒体数据
	{ path: 'dataReport/channelIncome', }, // 渠道数据
	{ path: 'financeAccount/mediaAccount', }, // 媒体对账单
	{ path: 'financeAccount/recordPayment', },
	{ path: 'SDKVersion/SDKVersion', }, // SDK版本管理
	{ path: 'userManage/userManage',  },
	{ path: 'userManage/roleManage', }, // 角色管理
]
const router = new VueRouter({
	routes
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	// console.log(to.path)
	if(localStorage.getItem('sdk-routes')&&sessionStorage.getItem("token-sdk-system")){
		let routeList = JSON.parse(localStorage.getItem('sdk-routes'));
		let hasPermis = routeList.some((item) => ('/' + item.path) === to.path)
		let hasAllAuth = allAuthRoutes.some((items) => ('/' + items.path) === to.path)
		if(!hasPermis&&hasAllAuth){
			next('/404');
			// console.log('无权限')
		}
	}
	next()
})

export default router